
import {
  FaTachometerAlt,
  FaMapMarkedAlt,
  FaBuilding,
  FaBriefcase,
  FaClipboard,
  FaUser,
  FaLock,
  FaCog,
  FaSignOutAlt,
  FaQuestionCircle,
  FaPaperPlane,
  FaChartBar,
  FaExchangeAlt,
  FaServer,
  FaSyncAlt,
  FaCubes,
  FaCube,
  FaChartLine
} from 'react-icons/fa';

export default [
  {
    pages: [
      {
        page: 'home',
        title: 'Home',
        href: '/home',
        icon: FaTachometerAlt
      },

      {
        page: 'executivePanel',
        title: 'Painel Executivo',
        href: '/painel-executivo',
        icon: FaChartLine
      },

      {
        page: 'analytics',
        title: 'Analytics',
        href: '/analytics',
        icon: FaChartBar
      },

      {
        page: 'users',
        title: 'Usuários',
        href: '/users',
        icon: FaUser
      },
      {
        page: 'cooperatives',
        title: 'Matrizes',
        href: '/cooperatives',
        icon: FaBriefcase
      },
      {
        page: 'units',
        title: 'Unidades',
        href: '/units',
        icon: FaBuilding
      },
      {
        page: 'equipments',
        title: 'Equipamentos',
        href: '/equipments',
        icon: FaCubes
      },
      {
        page: 'nir',
        title: 'Nir',
        href: '/nir',
        icon: FaCube
      },
      {
        page: 'equipments',
        title: 'Server Local',
        href: '/server-local',
        icon: FaServer
      },
      {
        page: 'equipmentsreplace',
        title: 'Substituir',
        href: '/equipments-replace',
        icon: FaExchangeAlt
      },
      {
        page: 'updates',
        title: 'Atualizações',
        href: '/updates',
        icon: FaSyncAlt
      },
      /* {
        page: 'models3d',
        title: 'Modelos 3D',
        href: '/models-3d',
        icon: FaCube
      }, */
      {
        page: 'logs',
        title: 'Logs',
        href: '/logs',
        icon: FaCube
      },

      {
        title: 'Mapas',
        href: '/maps',
        icon: FaMapMarkedAlt,
        page: 'maps',
      },
      {
        title: 'Curvas',
        href: '/charts',
        icon: FaChartBar,
        page: 'charts',
        children: [
          {
            page: 'charts',
            title: 'Curvas',
            href: '/charts',
          },
          {
            page: 'charts',
            title: 'Atualizações',
            href: '/charts-atualizacoes',
          },
        ]
      },
      {
        title: 'Suportes',
        href: '/support',
        icon: FaQuestionCircle,
        page: 'support',
        children: [
          {
            page: 'support',
            title: 'Suporte',
            href: '/support',
          },
          {
            page: 'supportdry',
            title: 'Suporte DRY',
            href: '/supportdry',
          },
          {
            page: 'supportnir',
            title: 'Suporte NIR',
            href: '/supportnir',
          },
          {
            page: 'supportOrange',
            title: 'Suporte ORANGE',
            href: '/remote-access',
          },
          /* {
            page: 'supportiot',
            title: 'Suporte IOT',
            href: '/supportiot',
          }, */
        ]
      },
      {
        page: 'equipmentsQL',
        title: 'Qualidade',
        href: '/equipmentsQL',
        icon: FaClipboard
      },
      {
        page: 'userspassword',
        title: 'Gera Senha',
        href: '/userspassword',
        icon: FaLock
      },
      {
        page: 'notifications',
        title: 'Notificações',
        href: '/notifications',
        icon: FaPaperPlane
      },
      {
        page: 'general',
        title: 'Configurações',
        href: '/settings/general',
        icon: FaCog
      },
      {
        page: 'logout',
        title: 'Sair',
        href: '/logout',
        icon: FaSignOutAlt,
      }
    ]
  }
];
